import * as React from 'react';
export default function SvgSplit() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.928 17.336c0-1.066-.694-1.97-1.655-2.285v-2.623h7.976c.575 0 1.3.645 1.3 1.799v.89a2.405 2.405 0 1 0 1.5-.117v-.773c0-1.662-1.109-3.299-2.8-3.299H7.273V8.95a2.406 2.406 0 1 0-1.5 0v6.101a2.405 2.405 0 1 0 3.155 2.285ZM6.517 7.57a.905.905 0 1 1 .013-1.81.905.905 0 0 1-.013 1.81Z",
    fill: "currentColor"
  }));
}